import { useState, useEffect } from 'react';
import { isEmpty } from './func';
import { ageFromDate } from '../../libs/util';
import DatePicker from 'react-datepicker';
import {
  resolveDateShortcut,
  sanitizeDateInputText,
  toLocalDate,
} from '@sindi/product-engine/core';

import 'react-datepicker/dist/react-datepicker.css';

const Component = ({
  className,
  placeholder,
  value,
  onChange,
  onValidate,
  showError,
  minAge,
  minAgeMsg,
  required,
  disabled,
}) => {
  const [error, setError] = useState(null);

  const emitShortcutDate = (rawValue) => {
    const resolved = resolveDateShortcut(rawValue);
    if (!resolved || !onChange) return false;

    const date = toLocalDate(resolved);
    if (!date) return false;

    onChange(date);
    return true;
  };

  // PB-1945: no preventDefault - react-datepicker only mirrors typed text into
  // the visible input when the event is left un-prevented, so preventing it
  // swallowed every character that completed a tenor ("1m2d" showed as "12").
  const handleRawChange = (event) => {
    const input = event?.target;
    const rawValue = input?.value ?? '';
    const cleaned = sanitizeDateInputText(rawValue);

    // PB-1945: react-datepicker copies target.value after this handler runs, so
    // writing back here keeps a rejected character from ever being rendered.
    if (input && cleaned !== rawValue) {
      input.value = cleaned;
    }

    emitShortcutDate(cleaned);
  };

  const handleBlur = (event) => {
    emitShortcutDate(sanitizeDateInputText(event?.target?.value ?? ''));
  };

  const validate = () => {
    if (!value) {
      if (required) {
        return 'Required.';
      }
      return null;
    }

    if (minAge && minAge > 0 && ageFromDate(value) < minAge) {
      if (minAgeMsg) {
        return minAgeMsg;
      }
      return 'You must be at least ' + minAge + ' years old.';
    }
    return null;
  };

  useEffect(() => {
    let msg = validate();
    setError(msg);
    if (onValidate) {
      onValidate(msg == null);
    }
  }, [value]);

  return (
    <div className="node-control">
      {/* <input type="text" className={className}
        placeholder={placeholder}  disabled={disabled}
        value={value}
        onChange={onChange}/> */}
      <DatePicker
        className={className}
        placeholderText={placeholder}
        disabled={disabled}
        dateFormat="dd-MM-yyyy"
        showYearDropdown
        yearDropdownItemNumber={100}
        scrollableYearDropdown
        selected={value}
        onChange={onChange}
        onChangeRaw={handleRawChange}
        onBlur={handleBlur}
      />
      {error && showError && <span className="invalid">{error}</span>}
    </div>
  );
};

export default Component;
